import React from "react";
import _ from 'lodash';
import { useSelector } from "react-redux";
import { URvoicemailSkeleton } from "../../../../shared/skeletonLoading/voicemailSkeleton";
import RecInnerTop from "./recInnerTop/index";
import RecBox from "./recInnerBox";
import { initialStateModel } from "../../../../models/model";
import NoCalls from "../../leftsidebar/noCalls";
import VoiceMailNoData from "../../../../styles/images/empty_states/empty-voicemail.svg";

export default function RecInner() {
  
  let { callReducer}: initialStateModel = useSelector((state: initialStateModel) => state);

  let { isParticularLoading, particularLog } = callReducer;

  return (
    <>
        {!isParticularLoading ?
        (!_.isEmpty(particularLog) ?
          <><RecInnerTop />
             <RecBox/> </> :
                  <NoCalls voiceMailEmptySrc={VoiceMailNoData} />
                
            ):(<URvoicemailSkeleton/>)
            
            

}
    </>
  );
};
